<template>
    <div>
        <internal-header v-if="!pdf_view" heading="Productions"/>
        <productions-report-filters
            v-if="$vuetify.breakpoint.mdAndUp && !pdf_view"
            v-model="filters"
            :constants="constants"
            :valuelists="valuelists"
            />
        <v-expansion-panels v-else-if="!pdf_view" flat>
            <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                    <template v-slot:default="{ open }">
                        <v-container class="py-0">
                            <v-row no-gutters>
                                <v-col cols="11" class="tw-text-lg">Filters<span v-show="!!filters_used">: {{ filters_used }}</span></v-col>
                                <v-col cols="1">
                                    <v-icon>
                                        <template v-if="open">mdi-minus-circle</template>
                                        <template v-else>mdi-plus-circle</template>
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <productions-report-filters
                        v-model="filters"
                        :constants="constants"
                        :valuelists="valuelists"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div v-if="!pdf_view" class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-pt-2 tw-pb-1 tw-border-b tw-border-t tw-border-dark-grey">
            <div v-if="!pdf_view" class="flex-grow-1 tw-text-xl tw-font-light" v-show="num_records_filtered">{{ num_records_filtered }} Records</div>
            <div v-if="!pdf_view" v-show="records_are_present" @click="exportAsPdf()" class="flex-grow-0 tw-px-3 tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer">Print List</div>
        </div>

        <div class="print-container" v-for="(production, production_index) in items_local" :key="production.id">
            <v-card flat
                    class="pa-1 my-1 tw-my-0 tw-mr-0 mt-0 pt-0 mb-0 print-half-page">

                <v-card-title class="pt-0 pb-2">
                    <span :style="{'color':getProductionColour(production)}">{{ production.name }}</span>
                </v-card-title>
                <v-card-subtitle class="d-flex justify-content-between align-items-center pb-2">
                    <v-container fluid class="mt-0">
                        <v-row>
                            <v-col cols="12" class="pt-1 pb-1">
                                <v-row>
                                    <v-col cols="4" :style="{'color':getProductionColour(production)}">
                                        {{ production.company }}
                                    </v-col>
                                    <v-col cols="4" :style="{'color':getProductionColour(production)}" class="text-center">
                                        <strong >{{ (production.status)?.toUpperCase() }}</strong>
                                    </v-col>

                                    <v-col cols="4" :style="{'color':getProductionColour(production)}" class="text-right">
                                        <strong>{{ getDisplayDateRange(production) }}</strong>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>

                </v-card-subtitle>

                <v-card-text>
                    <v-container fluid class="mt-0">
                        <v-row>
                            <v-col cols="12" class="pt-1">
                                <v-row>
                                    <v-col cols="4" class="pa-0">
                        <v-card color="#eeeeee" flat class="mr-auto mx-2 shady-box">
                            <v-card-subtitle class="mb-0 pb-0 pt-1"><strong>Information</strong></v-card-subtitle>
                            <v-card-text class="my-0 darker-text">
                                <p class="my-0">{{ production.genre }}</p>
                                <p class="my-0" :style="{'color':getContractColour(production)}">
                                    {{ production.contract?.name }}</p>
                            </v-card-text>
                            <v-card-subtitle v-if="production.note" class="my-0" :class="[noPaddingWhenPrinting]"><strong>Notes </strong>{{ production.note }}</v-card-subtitle>
                        </v-card>
                                    </v-col>

                                    <v-col cols="4" class="pa-0">
                        <v-card color="#eeeeee" flat class="mr-auto mx-2 shady-box">
                            <v-card-subtitle class="mb-0 pb-0 pt-1"><strong>Contact</strong></v-card-subtitle>
                            <v-card-text class="pb-0 darker-text">
                                <p class="my-0">{{ getDisplayAddressLine1(production) }}</p>
                                <p class="my-0">{{ getDisplayAddressLine2(production) }}</p>
                                <p class="my-0">{{
                                        $root.formatPhoneDisplay(production.telephone_report?.telephone_fax)
                                    }}</p>
                                <p class="my-0">{{ production.email_report?.email }}</p>
                            </v-card-text>
                        </v-card>
                                    </v-col>

                                    <v-col cols="4" class="pa-0">
                                    <v-card color="#eeeeee" flat class="mr-auto mx-2 shady-box">
                            <v-card-subtitle class="mb-0 pb-0 pt-1"><strong>Staff</strong></v-card-subtitle>
                            <v-card-text class="pb-0 darker-text">
                                <div v-for="staff in production.staff" :key="staff.id" class="my-0 py-0">
                                    <span>{{ staff.staff_role?.name }}</span> &nbsp;&nbsp;&nbsp;
                                    <span><strong>{{ staff.name }}</strong></span>
                                </div>
                            </v-card-text>
                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                    <hr :style="{'background-color':getProductionColour(production), 'height': '2px', 'border': 'none', 'margin-left': '10px'}"/>
                    <v-container fluid class="mt-0">
                        <v-row>
                            <v-col cols="12" class="pt-1">
<!--                                <div class="tw-my-1 tw-py-0 tw-border-b-2 tw-border-gray-500">
                                    <h5>Crew</h5>
                                </div>-->
                                <v-row>
                                    <!-- First Column (Camera A - Main) -->
                                    <v-col cols="4">

                                        <div v-for="crew in sortedCrewGroups[production_index].A_Main" :key="crew.id" class="my-0 py-0 darker-text">
                                            <span>{{ function_name_abbreviated(crew.title_function) }}</span>
                                            <span><strong>{{ crew.member?.first_name }} {{ crew.member?.last_name }}
                                            <span v-if="crew.member?.designation">({{
                                                    crew.member?.designation
                                                }})</span>
                                    </strong> {{ crew?.note }}</span>
                                        </div>
                                    </v-col>

                                    <!-- Second Column (Camera B - Main) -->
                                    <v-col cols="4">

                                        <div v-for="crew in sortedCrewGroups[production_index].B_Main" :key="crew.id" class="my-0 py-0 darker-text">
                                            <span>{{ function_name_abbreviated(crew.title_function) }}</span>
                                            <span><strong>{{ crew.member?.first_name }} {{ crew.member?.last_name }}
                                            <span v-if="crew.member?.designation">({{
                                                    crew.member?.designation
                                                }})</span>
                                            </strong> {{ crew?.note }}</span>
                                        </div>
                                    </v-col>

                                    <!-- Third Column (Secondary Units) -->
                                    <v-col cols="4">

                                        <div v-for="crew in sortedCrewGroups[production_index].Secondary" :key="crew.id" class="my-0 py-0 darker-text">
                                            <span>{{ function_name_abbreviated(crew.title_function) }}</span>
                                            <span><strong>{{ crew.member?.first_name }} {{ crew.member?.last_name }}
                                            <span v-if="crew.member?.designation">({{
                                                    crew.member?.designation
                                                }})</span>
                                            </strong> {{ crew?.note }}</span>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </div>

    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader.vue";
    import ProductionsReportFilters from "@/Pages/InternalPages/Reports/ProductionsReportFilters.vue";

    export default {
        name: "ProductionsReport",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            InternalHeader,
            SmartTable,
            ProductionsReportFilters,
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'items': {          // Will optionally accept a hardcoded list of items instead of getting smart table to fetch them
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'pdf_view': {          // Indicates if this instance is a PDF view
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
        },
        data() {
            return {
                constant: this.constants,
                filters: {
                    search: null,
                    report_date: new Date,
                },
                fetch_data_response: null,
                items_local: this.items || null,
            }
        },
        computed: {
            headers() {
                return [
                    // {value: 'id',           text: 'ID',         align: `start`, sortable: false, filterable: true,   },
                    {value: 'name',         text: 'Name',       align: `start`, sortable: false, filterable: true,   },
                    {value: 'company',      text: 'Company',    align: `start`, sortable: false, filterable: true,   },
                    {value: 'genre',        text: 'Genre',      align: `start`, sortable: false, filterable: true,   },
                ]
            },
            filters_used() {
                let filters_used = Object.keys(this.filters).filter(filter => (!!this.filters[filter] && this.filters[filter].length))
                if (filters_used?.length === 4) return "All"
                if (!filters_used || filters_used.length === 0) return ""
                return filters_used?.join(", ").toProperCase()
            },
            num_records_total() {
                return this.items_local?.length
            },
            num_records_filtered() {
                return this.items_local?.length
            },
            records_are_present() {
                return this.items_local?.length
            },
            sortedCrewGroups() {
                return this.items_local.map(production => {
                    let groups = { A_Main: [], B_Main: [], Secondary: [] }
                    let leftovers = { A_Main: [], B_Main: [] }

                    production.crew_report.forEach(crew => {
                        let groupKey = `${crew.camera}_${crew.unit}`
                        if (groupKey === 'A_Main') {
                            if (groups.A_Main.length < 9) {
                                groups.A_Main.push(crew)
                            } else {
                                leftovers.A_Main.push(crew)
                            }
                        } else if (groupKey === 'B_Main') {
                            if (groups.B_Main.length < 9) {
                                groups.B_Main.push(crew)
                            } else {
                                leftovers.B_Main.push(crew)
                            }
                        } else {
                            groups.Secondary.push(crew)
                        }
                    })

                    // Sort each group by priority
                    for (let group in groups) {
                        groups[group].sort((a, b) => a.priority - b.priority)
                    }

                    groups.Secondary = [...leftovers.A_Main, ...leftovers.B_Main, ...groups.Secondary].slice(0, 10)

                    return groups
                })

            },
            noPaddingWhenPrinting() {
                let default_padding = 2;
                return this.pdf_view ? `py-0` : `py-${default_padding}`
            }
        },
        mounted() {
            this.fetchData()
        },
        methods: {
            fetchData() {
                if (!!this.items) {
                    return
                }
                axios.post(
                    route('reports.list.productions').url()
                ).then((response)=>{
                    this.items_local = response?.data?.data
                }).catch((error)=>{
                    this.$root.snackbar.error(error)
                })
            },
            receivedRecordsUpdate(response) {
                this.fetch_data_response = response
            },
            getDefaultItemsPerPage() {
                return this.pdf_view ? -1 : 20
            },
            getDefaultItemsPerPageOptions() {
                return this.pdf_view ? [-1] : [5, 10, 20, 30]
            },
            getDisplayDateRange(production) {
                return [this.getDateFormattedStringFromDate(production.date_start), this.getDateFormattedStringFromDate(production.date_wrap)].filter((this_date) => this_date)?.join(' - ')
            },
            getDisplayAddressLine1(production) {
                let two_lines = production?.production_office_address?.length ? production.production_office_address[0].two_line_address : null
                if (!two_lines) {
                    return ""
                }
                let address_array = two_lines.split('\n')
                return address_array?.length ? address_array[0]?.trim() : ""
            },
            getDisplayAddressLine2(production) {
                let two_lines = production?.production_office_address?.length ? production.production_office_address[0].two_line_address : null
                if (!two_lines) {
                    return ""
                }
                let address_array = two_lines.split('\n')
                return address_array?.length > 1 ? address_array[1]?.trim() : ""
            },
            getDateFormattedStringFromDate(date_input) {
                if (!date_input) {
                    return null
                }
                let actual_date = date_input instanceof Date ? date_input : new Date(`${date_input}T00:00:00`)
                return actual_date.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"})
            },
            getProductionColour(production) {
                switch (production.print_color) {
                    case "Black":
                    case "Orange":
                        return production.print_color.toLowerCase()
                    case "Red":
                        return '#b91c1c'
                    case "Blue":
                        return '#1d4ed8'
                    case "Green":
                        return '#047857'
                    case "Purple":
                        return '#6d28d9'
                    default:
                        return ''
                }
            },
            getContractColour(production) {
                switch (production.contract?.name) {
                    case "DISPENSATION":
                    case "IA 667 One Page Agreement":
                        return 'orange'
                    default:
                        return ''
                }
            },
            async exportAsExcel() {
                // await this.$refs.report_list.getExport() /* How it's done when you want to export without queue -- Only exports visible records */
                await this.$refs.report_list.getExcel()
            },
            async exportAsPdf() {

                let payload = {date:this.filters?.report_date}
                let ajax_uri = route('reports.productions.queue', 'pdf').url()
                let ajax_method = 'post'

                axios({
                    url: ajax_uri,
                    method: ajax_method,
                    data: payload,
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.snackbar.success(`You will receive an email to ${this.$page.user?.email} with the PDF once it is ready.`)
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                    })


            },
            function_name_abbreviated(crew_title){
                return crew_title?.name_for_report // name_for_report is a Model attribute that returns the name or abbreviation appropriately
            },
        },
        watch: {
            items: {
                handler(newVal, oldVal) {
                    // this.items just got updated
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>

<style>
.row-pointer tbody tr {
    cursor: pointer;
}

.force-full-height {
    height: 100vh !important;
    width: 100vw !important;
}

.darker-text {
    color: #111111 !important;
}

/*This is the screen version*/
.shady-box {
    height: 125px;
    min-height: 125px;
    max-height: 125px;
}

@page  {
    size: letter landscape;
}


@media print {

    html, body {
        font-size: 10pt;
        margin-top: -50px;
    }

    body {
        margin: 0;
        padding: 0;
    }

    /* takes up half of a page */
    .print-half-page {
        height: 47vh;
        box-sizing: border-box;
        overflow:hidden;
        page-break-inside: avoid;
    }

    /*This is the print version*/
    .shady-box {
        height: 108px;
        min-height: 108px;
        max-height: 108px;
    }

    .page-title {
        margin-bottom: 0;
    }

    .print-container:first-of-type {
        margin-top: -38px !important;
    }

}


</style>
